import type { Insight } from '@/types/insight';
import InsightCard from '../InsightCard';
import { useInsightEditor } from './InsightEditorContext';

// Renders the real public InsightCard, filled with the current editor form
// state, so the author sees exactly how the card (and its 3:2 thumbnail) will
// look once published. The card is wrapped non-interactively to suppress its
// navigation / like / share side effects in the editor.
const InsightCardPreview = () => {
  const {
    title_en,
    title_ko,
    description_en,
    description_ko,
    thumbnail_url,
    reading_time,
    external_url,
    tags,
    currentLanguage,
  } = useInsightEditor();

  const previewLanguage = currentLanguage === 'ko' ? 'KO' : 'EN';

  const now = new Date().toISOString();

  const previewInsight: Insight = {
    id: 'preview',
    title_en: title_en || 'Your insight title will appear here',
    title_ko: title_ko || null,
    content_en: null,
    content_ko: null,
    description_en:
      description_en || 'Your insight description preview will appear here as you type.',
    description_ko: description_ko || null,
    meta_description_en: '',
    meta_description_ko: null,
    meta_keywords_en: [],
    meta_keywords_ko: [],
    external_url: external_url || null,
    is_published: false,
    status: 'draft',
    tags: tags || [],
    thumbnail_url: thumbnail_url || null,
    created_at: now,
    updated_at: now,
    views_count: 0,
    likes_count: 0,
    slug: '',
    slug_en: null,
    slug_ko: null,
    author: '',
    reading_time: reading_time ?? 5,
    published_at: now,
    last_auto_save: null,
  };

  return (
    <div className="w-full max-w-[300px] select-none" aria-hidden="true">
      <div className="pointer-events-none">
        <InsightCard
          insight={previewInsight}
          language={previewLanguage}
          showImagePlaceholder
        />
      </div>
    </div>
  );
};

export default InsightCardPreview;
